
import React, { FC, useState, memo, useEffect, useMemo } from "../../../../lib/teact/teact";
import LotLoading from "../../ui/loading";
import ReportApi from "../../restapi/reportApi";
import InfiniteScroll from "../../../ui/InfiniteScroll";
import ListItem from "../../../ui/ListItem";

import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import MessageView from "./messageView";
import store from "../../store";
import { LotScreenSettings } from "../../config/uiconfig";
import { GetGuestContactId, isGuest } from "../../utils/guest";
import { DetailsDataItem, sortArray, SortCriteria } from "../../utils/sortUtils";
import { buildDetailsReportHtml, buildDetailsRowViewModel, renderDetailsRow } from "./detailsReportRenderUtils";
import { buildReportHtmlDocument, buildReportMessageMetaHtml } from "./reportHtmlDocument";

const detailsReportDataCache = new Map<string, DetailsDataItem[]>();

function getDetailsReportCacheKey(message: any): string {
    const messageId = message?.messageId ?? 0;
    if (messageId != 0) {
        return `message:${messageId}`;
    }
    const mienDaiCuocId = message?.mienDaiCuocId ?? "";
    const date = store.getState().global.workDate || "";
    const currentContact: any = store.getState().contact.currentContact;
    const contactId = isGuest() ? GetGuestContactId() : (currentContact ? currentContact.contactId : 0);
    return `contact:${contactId}|mien:${mienDaiCuocId}|date:${date}`;
}

export function getCachedDetailsReportData(message: any): DetailsDataItem[] | undefined {
    const key = getDetailsReportCacheKey(message);
    const cached = detailsReportDataCache.get(key);
    return cached ? [...cached] : undefined;
}


type OwnProp = {
    onChangeScreen: (toScreen: LotScreenSettings) => void;
    onChangeViewType: (viewType: string, index: number) => void;
    message: any;
    index: number;
    onRemoveItem: (index: number) => void;
    soTin: number;
}

export async function fetchDetailsReportData(message: any): Promise<DetailsDataItem[]> {
    let result: any;
    if (message.messageId != 0) {
        result = await ReportApi.FetchDetailsReportByMessageID({
            messageId: message.messageId,
            mienDaiCuocId: message.mienDaiCuocId
        })
    } else {
        const currentContact: any = store.getState().contact.currentContact;
        const contactId = isGuest() ? GetGuestContactId() : (currentContact ? currentContact.contactId : 0)
        result = await ReportApi.FetchDetailsReportByContactID({
            contactId: contactId,
            mienDaiCuocId: message.mienDaiCuocId,
            ngay: store.getState().global.workDate
        })
    }
    const data: DetailsDataItem[] = result.data ? result.data : [];
    detailsReportDataCache.set(getDetailsReportCacheKey(message), [...data]);
    return data;
}

export async function getDetailsReportDisplayHtml(
    message: any,
    data?: DetailsDataItem[],
): Promise<string> {
    const detailsData = data ?? getCachedDetailsReportData(message) ?? await fetchDetailsReportData(message);
    return buildReportHtmlDocument(
        buildDetailsReportHtml(detailsData),
        "Details Report",
        buildReportMessageMetaHtml(message),
    );
}

const DetailsReport: FC<OwnProp> = ({
    onChangeViewType,
    message,
    index,
    onRemoveItem,
    onChangeScreen,
    soTin,
}) => {
    const [state, setState] = useState({
        data: [] as any[],
        dataOrigin: [] as any[],
        isLoading: false,
        sorted: { dai: 0, loai: 0, so: 0, diem: 0, trung: -1 },

    })
    useEffect(() => {
        const fetchData = async () => {
            // const messageId = store.getState().basicReport.curMessgageId
            setState(prev => ({ ...prev, data: [], isLoading: true }))
            return fetchDetailsReportData(message);
        }
        // if (message.messageId == "0") {
        //     return;
        // }
        fetchData().then((result: any) => {
            const cloned = [...result];
            setState(prev => ({ ...prev, data: cloned, dataOrigin: cloned, isLoading: false }))
        })
    }, [])
    const listIds = useMemo(() => {
        const ret: any[] = []
        for (let i = 0; i < state.data.length; i++)
            ret.push(i)
        return ret
    }, [state.data])
    const [viewportIds, getMore] = useInfiniteScroll(undefined, listIds, false, 50, undefined);
    function handleRemoveItem(index: number) {
        if (onRemoveItem)
            onRemoveItem(index)
    }
    function getSortedArrow(sortedNum: number): string {
        if (sortedNum == 1)
            return '↑'
        if (sortedNum == -1)
            return '↓'

        return ''
    }
    function getNextSortedNum(curNum: number): number {
        if (curNum == 0) {
            curNum = -1
        } else if (curNum == -1) {
            curNum = 1
        } else if (curNum == 1) {
            curNum = 0
        }
        const result = curNum
        return result
    }

    useEffect(() => {
        const sortOrder: SortCriteria<DetailsDataItem>[] = []
        if (state.sorted.dai == 1)
            sortOrder.push({ key: 'daiId1', order: 'asc' })
        if (state.sorted.dai == -1)
            sortOrder.push({ key: 'daiId1', order: 'desc' })
        //
        if (state.sorted.loai == 1)
            sortOrder.push({ key: 'loaiCuocId', order: 'asc' })
        if (state.sorted.loai == -1)
            sortOrder.push({ key: 'loaiCuocId', order: 'desc' })
        //
        if (state.sorted.so == 1)
            sortOrder.push({ key: 'soCuoc', order: 'asc' })
        if (state.sorted.so == -1)
            sortOrder.push({ key: 'soCuoc', order: 'desc' })
        //
        if (state.sorted.diem == 1)
            sortOrder.push({ key: 'diem', order: 'asc' })
        if (state.sorted.diem == -1)
            sortOrder.push({ key: 'diem', order: 'desc' })
        //
        if (state.sorted.trung == 1)
            sortOrder.push({ key: 'trung', order: 'asc' })
        if (state.sorted.trung == -1)
            sortOrder.push({ key: 'trung', order: 'desc' })
        const sourceData = [...state.dataOrigin];
        if (sortOrder.length > 0) {
            const sortedData = sortArray(sourceData, sortOrder)
            setState(prev => ({ ...prev, data: sortedData }))
        } else {
            setState(prev => ({ ...prev, data: sourceData }))
        }
    }, [state.sorted, state.dataOrigin])
    useEffect(() => {
        detailsReportDataCache.set(getDetailsReportCacheKey(message), [...state.data]);
    }, [message, state.data])
    return (
        <div className="form-main">
            <div className="card-container">
                {message &&
                    <MessageView data={message} messageIndex={index}
                        onChangeViewType={onChangeViewType}
                        onRemoveItem={handleRemoveItem}
                        onChangeScreen={onChangeScreen}
                        soTin={soTin}
                    />
                }
                <div className="">
                    <div className="details-row">
                        <div className="details-header"
                        //onClick={() => setState(prev => ({ ...prev, sorted: { ...prev.sorted, dai: getNextSortedNum(prev.sorted.dai) } }))}
                        >
                            Đài<span>{getSortedArrow(state.sorted.dai)}</span></div>
                        <div className="details-header">Loại</div>
                        <div className="details-header">Số</div>
                        <div className="details-header right"
                            onClick={() => {
                                setState(prev => ({ ...prev, sorted: { ...prev.sorted, diem: getNextSortedNum(prev.sorted.diem) } }))

                            }
                            }
                        >
                            Điểm<span>{getSortedArrow(state.sorted.diem)}</span></div>
                        <div className="details-header right"
                            onClick={() => {
                                setState(prev => ({ ...prev, sorted: { ...prev.sorted, trung: getNextSortedNum(prev.sorted.trung) } }))

                            }
                            }
                        >
                            Trúng<span>{getSortedArrow(state.sorted.trung)}</span></div>
                    </div>
                    <InfiniteScroll
                        style="max-height:50vh;height:auto;"
                        items={viewportIds} onLoadMore={getMore}
                        className="chat-list custom-scroll"
                    >
                        {
                            state.isLoading && <LotLoading key="loading-dtls" />
                        }
                        {viewportIds &&
                            viewportIds.length &&
                            viewportIds.map((item, index) => {
                                const row: DetailsDataItem = state.data[item]
                                const viewRow = buildDetailsRowViewModel(row)
                                return (
                                    <div key={"dtls-key-" + item} id={"dtls-id-" + item} style="width:100%;">
                                        <ListItem className="Listitem-button-nopadding-all"
                                        >
                                            {renderDetailsRow(viewRow)}

                                        </ListItem>
                                    </div>
                                )
                            })

                        }
                    </InfiniteScroll>
                </div>
            </div>
        </div>
    )
}

export default memo(DetailsReport)